import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<string, string[] | [string, string, string[] | string][] | null> => {
  return {
    // segments holds at most ["sku"] (the only offered segment).
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
  };
};
